import { BaseNode } from './BaseNode';

export function JoinNode({ data }: { data: { label: string } }) {
  return <BaseNode type="join" label={data.label} lines={[{ text: 'Waits for all branches' }]} />;
}
